import { Button, Dialog, DialogContent, Typography, TextField } from "@mui/material";
import { useState, useEffect } from "react";
import RefIndexMasking from "./RefIndexMasking";
import HistoricalData from "./HistoricalData";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { url } from "../../api/axios_client";
import axios from "../../api/axios_client";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CloseIcon from "@mui/icons-material/Close";
import "./style.css";
import ResultComponent from "./ResultComponent";
import GraphComponent from "./GraphComponent";
import { TrophySpin } from "react-loading-indicators";
import zScoreLegend from "./Z-Score-vert.png";
import { PhotoProvider, PhotoView } from "react-photo-view";
import ReportPreview from "../../components/ReportPreview";
import {
  setAddedIndexesInit,
  setAddedIndexesId,
  setAddedIndexesName,
  setIsSingleIndex,
  clearAddIndexes,
  setAddIndexes,
  setLastSingleIndexInputs,
  setLastMultibleIndexInputs,
} from "../../reducers/MonitoringSlice";


const MonitoringDialog = ({ isSingleIndex, currentIndexId, requestSource, open, handleClose }) => {
  const dispatch = useDispatch();

  const getIndexesFromCategories = () => {
    try {
      const categoriesStr = localStorage.getItem('categories');
      if (!categoriesStr) return [];

      const categories = JSON.parse(categoriesStr);
      // Map categories to required format
      return categories.map(category => ({
        id: category.id,
        name: category.name,
        key: category.name.toLowerCase(), // or use category.type if you prefer
        available_from: category.available_from,
        available_to: category.available_to
      }));
    } catch (error) {
      console.error('Error parsing categories from localStorage:', error);
      return [];
    }
  };

  const addedIndexes = useSelector((state) => state.monitoringState.addedIndexes);
  const lastIsSingleIndex = useSelector((state) => state.monitoringState.isSingleIndex)
  const lastMultibleIndexInputs = useSelector((state) => state.monitoringState.lastMultibleIndexInputs)
  const lastSingleIndexInputs = useSelector((state) => state.monitoringState.lastSingleIndexInputs)
  const indexes = getIndexesFromCategories();

  useEffect(() => {
    if (isSingleIndex !== lastIsSingleIndex) {
      dispatch(setIsSingleIndex(isSingleIndex));
      if (isSingleIndex) {
        dispatch(setLastMultibleIndexInputs(addedIndexes));
      } else {
        dispatch(setLastSingleIndexInputs(addedIndexes));
      }
      dispatch(clearAddIndexes())
      if (isSingleIndex) {
        if (lastSingleIndexInputs.length === 0) {
          dispatch(setAddedIndexesInit());
        } else {
          dispatch(setAddIndexes(lastSingleIndexInputs));
        }
      } else {
        dispatch(setAddIndexes(lastMultibleIndexInputs));
      }
    }
    if (isSingleIndex) {
      const singleIndex = indexes.find((index) => index.id === currentIndexId);
      dispatch(setAddedIndexesId({ index: 0, id: singleIndex.id }));
      dispatch(setAddedIndexesName({ index: 0, name: singleIndex.name }));
    }
  }, [isSingleIndex, currentIndexId, lastIsSingleIndex]);

  const dialogStyle = {
    position: "absolute",
    top: 0,
    right: 0,
    height: "100%",
    width: "100%",
    margin: "0",
    textAlign: 'left',
    direction: 'ltr',
  };

  const [responseData, setresponseData] = useState(null);
  const [loading, setloading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [additionalInformation, setAdditionalInformation] = useState('');
  const [additionalInformationAr, setAdditionalInformationAr] = useState('');
  const RefIndex = useSelector((state) => state.monitoringState.RefIndex);
  const validateData = () => {
    // area
    if (!areas || !areas[0] || !areas[0].coordinates) {
      toast.error("Please select the area you want to be monitored");
      return false;
    }
    // historical data check
    if (!requestSource) {
      toast.error("Please select the main index for Monitoring");
      return false;
    }

    // added index validation
    for (let histDataLoop of addedIndexes) {
      // Check if index is selected (not empty)
      if (!histDataLoop.name || histDataLoop.name === "") {
        toast.error("Please select the name for your historical index");
        return false;
      }

      // Check date range validation
      if (!histDataLoop.from_date || !histDataLoop.to_date) {
        toast.error("Please select date range for historical index");
        return false;
      }

      // Filter validation with minimum constraints
      if (histDataLoop.filterToggle) {
        const window = parseInt(histDataLoop.window);
        const order = parseInt(histDataLoop.order);

        if (!histDataLoop.order || !histDataLoop.window ||
          histDataLoop.window === "" || histDataLoop.order === "") {
          toast.error("Please select filter values for historical data");
          return false;
        }

        // Minimum days = 3
        if (window < 3) {
          toast.error("Minimum days should be 3 or more");
          return false;
        }

        // Minimum order = 1
        if (order < 1) {
          toast.error("Minimum order should be 1 or more");
          return false;
        }

        // Order should be < days
        if (order >= window) {
          toast.error("Order should be less than days");
          return false;
        }
      }

      if (!histDataLoop.shortTermMonitoring) {
        toast.error(
          "Please select short term monitoring year for historical index"
        );
        return false;
      }
    }

    const isValidDate = (date) => {
      if (!date) return false;
      if (typeof date === 'object' && Object.keys(date).length === 0) return false;
      return true;
    };

    // ref/mask validation
    if (refToggle) {
      // Check if mask index is selected (not empty)
      if (!refData.id && !refData.uploaded) {
        toast.error("Please select the mask index for Monitoring");
        return false;
      }

      // If masking is toggled, date range is required
      if (!isValidDate(refFromDate) || !isValidDate(refToDate)) {
        toast.error("Please select date range for the masking index");
        return false;
      }

      // Updated error message
      if (rangePairs.length <= 0 && values.length <= 0) {
        toast.error("Please select at least one range or value for masking");
        return false;
      }
    }

    return true; // All validations passed
  };

  //   submit
  const areas = useSelector((state) => state.mapState.areas);

  // ref index

  const rangePairs = useSelector((state) => state.monitoringState.rangePairs);
  const values = useSelector((state) => state.monitoringState.values);
  const refToggle = useSelector((state) => state.monitoringState.refToggle);

  const [sliderPage, setsliderPage] = useState({
    historical: true,
    mask: false,
    additionalInfo: false,
    result: false,
  });

  const handleRight = () => {
    setsliderPage((prevSliderPage) => {
      let nextSliderPage = { ...prevSliderPage };
      const allPages = Object.keys(nextSliderPage);

      // Filter out additionalInfo page if requestSource is not "reporting"
      const availablePages = requestSource === "reporting"
        ? allPages
        : allPages.filter(page => page !== 'additionalInfo');

      const currentPageIndex = availablePages.findIndex((page) => nextSliderPage[page]);

      if (currentPageIndex === availablePages.length - 1) {
        return prevSliderPage;
      }

      // Set the current page to false
      nextSliderPage[availablePages[currentPageIndex]] = false;

      // Set the next page to true
      nextSliderPage[availablePages[currentPageIndex + 1]] = true;

      return nextSliderPage;
    });
  };

  const handleLeft = () => {
    setsliderPage((prevSliderPage) => {
      let nextSliderPage = { ...prevSliderPage };
      const allPages = Object.keys(nextSliderPage);

      // Filter out additionalInfo page if requestSource is not "reporting"
      const availablePages = requestSource === "reporting"
        ? allPages
        : allPages.filter(page => page !== 'additionalInfo');

      const currentPageIndex = availablePages.findIndex((page) => nextSliderPage[page]);

      if (currentPageIndex === 0) {
        return prevSliderPage;
      }

      // Set the current page to false
      nextSliderPage[availablePages[currentPageIndex]] = false;

      // Set the previous page to true
      nextSliderPage[availablePages[currentPageIndex - 1]] = true;

      return nextSliderPage;
    });
  };
  const handleSubmit = async () => {
    try {
      if (!validateData()) {
        setloading(false);
        return;
      }
      setSubmitted(true);
      setloading(true);

      // Create FormData object
      const formData = new FormData();

      // Add the file if mask upload is enabled
      if (uploadMaskToggle && maskingFileContent) {
        formData.append('mask_file', maskingFileContent);
      }

      // Create the JSON payload
      const jsonData = {
        mask: {
          ...refData,
          // Remove the actual file from JSON since we're sending it separately
          upload_tif: null
        },
        indices: addedIndexes,
        coords: Array.isArray(areas[0].coordinates) ? areas[0].coordinates : null,
        geo: Array.isArray(areas[0].coordinates) ? null : JSON.stringify(areas[0].coordinates),
        ...(requestSource === "reporting" && {
          additional_information: additionalInformation || '',
          additional_information_ar: additionalInformationAr || '',
        }),
        source: requestSource
      };

      // Add the JSON data as a string
      formData.append('json_data', JSON.stringify(jsonData));

      console.log("formData", formData)

      const res = await axios.post(`${url}/monitoring/monitoring`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        },
      });


      if (res.status === 200) {
        let result = await res.data;
        console.log("result", result.data);
        if (result && result.data) {
          toast.success("Report generated successfully");
          setresponseData(result);
        } else {
          toast.error("Something went wrong");
        }
      }
    } catch (error) {
      toast.error(error.response.data.message);
      console.log(error);
    } finally {
      setloading(false);
    }
  };

  // monitoring \ ref data
  const refFromDate = useSelector((state) => state.monitoringState.refFromDate);
  const refToDate = useSelector((state) => state.monitoringState.refToDate);
  const maskingFileContent = useSelector((state) => state.mapState.maskingFileContent);
  const uploadMaskToggle = useSelector((state) => state.monitoringState.uploadMaskToggle);
  const refData = {
    uploaded: uploadMaskToggle,
    upload_container: uploadMaskToggle ? "mask_container" : null,
    upload_tif: uploadMaskToggle ? maskingFileContent : null,
    id: uploadMaskToggle ? null : RefIndex[0],
    ranges: rangePairs,
    values: values,
    from_date: uploadMaskToggle ? {} : refFromDate,
    to_date: uploadMaskToggle ? {} : refToDate,
    maskToggle: refToggle
  };
  console.log("ref Data", refData);
  console.log("ref INDEX", RefIndex);

  console.log("response data", responseData);

  return (
    <Dialog
      open={open}
      fullScreen
      onClose={handleClose}
      PaperProps={{ sx: dialogStyle, style: { maxHeight: "None" } }}
      className="animated-dialog"
    >
      <DialogContent>
        {/* Content of your side modal goes here */}
        <CloseIcon
          sx={{
            cursor: "pointer",
            position: "absolute",
            right: "15px",
            color: "#329ace",
          }}
          onClick={handleClose}
        />

        <div className="pred-right-arrow" onClick={handleRight} dir="ltr">
          <span>Next</span> <ArrowForwardIosIcon />
        </div>
        <div className="pred-left-arrow" onClick={handleLeft} dir="ltr">
          <ArrowBackIosIcon /> <span>Previous</span>
        </div>
        {/* main index */}
        <div
          style={{
            display: sliderPage.historical ? "flex" : "none",
          }}
          className="monitoring-historical-container"
        >
          <HistoricalData
            isSingleIndex={isSingleIndex}
            currentIndexId={currentIndexId}
            requestSource={requestSource}
            indexes={indexes}
          />
        </div>
        <br />

        {/* ref index */}
        <div
          className="pred-main-container"
          style={{
            display: sliderPage.mask ? "flex" : "none",
          }}
        >
          <RefIndexMasking refToggle={refToggle} indexes={indexes} />
          <br />
          {/* Range of values */}
        </div>
        {/* Additional Information page */}
        {requestSource === "reporting" &&
          <div
            style={{
              display: sliderPage.additionalInfo ? "flex" : "none",
              justifyContent: 'center',
              alignItems: 'center',
            }}
            className="pred-main-container"
          >
            <div style={{ width: '100%', padding: '20px' }}>
              <Typography variant="h6" gutterBottom>
                Additional Information
              </Typography>

              <TextField
                label="Additional Information"
                multiline
                rows={7}
                fullWidth
                variant="outlined"
                value={additionalInformation}
                onChange={(e) => setAdditionalInformation(e.target.value)}
                placeholder="Enter any additional information..."
                inputProps={{ maxLength: 2000 }}
                style={{ marginBottom: '20px' }}
                helperText={`${additionalInformation.length}/2000`}
              />

              <TextField
                label="معلومات إضافية"
                multiline
                rows={7}
                fullWidth
                variant="outlined"
                value={additionalInformationAr}
                onChange={(e) => setAdditionalInformationAr(e.target.value)}
                placeholder="أدخل أي معلومات إضافية..."
                inputProps={{ maxLength: 2000, dir: 'rtl' }}
                style={{ marginBottom: '20px' }}
                helperText={`${additionalInformationAr.length}/2000`}
              />
            </div>
          </div>}
        <br />
        {/* result */}
        <div
          style={{
            display: sliderPage.result ? "flex" : "none",
            justifyContent: "center",
            alignItems: "center",
          }}
          className="pred-main-container"
        >
          {/* submit btn */}
          <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
            {requestSource === "reporting" && (
              <Button
                variant="contained"
                color="primary"
                target="_blank"
                rel="noopener noreferrer"
                className='pred-download-button'
                style={{ alignSelf: "center", width: "54em" }}
                disabled={addedIndexes.length > 0 ? false : true}
                onClick={handleSubmit}
              >
                {responseData && responseData.data ? `Re-generate Monitorting Report` : `Generate Monitorting Report`}
              </Button>
            )}
            {loading ? (
              <TrophySpin color="#3154cc" size="medium" text="" textColor="" />
            ) : requestSource !== "reporting" && (
              <Button
                variant="contained"
                onClick={handleSubmit}
                // className="submit-compare-buttons"
                disabled={false}
              // TO DO change disabled to function
              >
                {submitted ? "Resubmit" : "Submit"}
              </Button>
            )}
          </div>
          {requestSource === "reporting" && responseData && responseData.data && (
            <div style={{
              width: "100%",
              height: "100%",
              marginTop: "10%"
            }}>
              <ReportPreview source={requestSource} data={responseData.data} />
            </div>
          )}

          <br />
          {requestSource !== "reporting" && responseData &&
            responseData.data.map((data, index) => {
              return (
                <>
                  <div
                    key={index}
                    style={{
                      width: "100%",
                    }}
                  >
                    <ResultComponent
                      curentTime={data.current.time}
                      histTime={data.historical.time}
                      shortTime={data.short_term.time}
                      xAxis={data.x_axis}
                      name={`${data.name} Filtered`}
                      id={`chart-container-filtered-${index}}`} // Pass unique id here
                      current={data.current}
                      historical={data.historical}
                      shortTerm={data.short_term}
                      unit={data.unit}
                      filterToggle={true}
                    />
                    <br />
                    <br />
                    <div className="monitoring-z-score-container">
                      <div className="monitoring-z-score-legend-container">
                        <Typography className="monitoring-z-score-legend-title">
                          Z-Score Legend
                        </Typography>
                        <PhotoProvider>
                          <PhotoView src={zScoreLegend}>
                            <img
                              className="monitoring-z-score-legend-img"
                              src={zScoreLegend}
                              alt="z-score-legend"
                            />
                          </PhotoView>
                        </PhotoProvider>
                      </div>
                      <div
                        className="no-scrollbar z-score-sections-container"
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "2rem",
                          overflow: "auto",
                        }}
                      >
                        {/* Historical Z-Score Section */}
                        <div style={{ flex: 1 }}>
                          <Typography className="monitoring-z-score-legend-title">
                            Historical Z-Score
                          </Typography>
                          <div className="z-score-container-scroll">
                            {data.z_score &&
                              data.z_score.map((graph, index) => {
                                return (
                                  <GraphComponent key={index} graph={graph} />
                                );
                              })}
                          </div>
                        </div>

                        {/* Short-term Z-Score Section */}
                        <div style={{ flex: 1 }}>
                          <Typography className="monitoring-z-score-legend-title">
                            Short term z-Score
                          </Typography>
                          <div className="z-score-container-scroll">
                            {data.z_score_st &&
                              data.z_score_st.map((graph, index) => {
                                return (
                                  <GraphComponent key={index} graph={graph} />
                                );
                              })}
                          </div>
                        </div>
                      </div>
                    </div>
                    <br />
                  </div>
                  <br />
                  <br />
                </>
              );
            })}
          <br />
        </div>
        <br />
      </DialogContent>
    </Dialog>
  );
};

export default MonitoringDialog;
